<template>
  <div class="d-flex flex-column g-4">
    <FileInputView :value="value" @update:value="value = $event; submit()" :endpoint="config.endpoint" :method="config.method" :extensions="config.extensions"/>
  </div>
</template>

<script setup>
import FileInputView from "../../../forms/inputs/FileInputView.vue";
import {ref} from "vue";

const props = defineProps({
  editor: Object,
  config: Object
});

const value = ref(undefined);

const emit = defineEmits(["submit"]);

function submit() {
  emit("submit");
  props.editor.chain().focus().setImage({ identifier: value.value.identifier, src: value.value.url }).run();
}

</script>